import UrlRouter from 'url-router';
import UrlBuilder from 'tools/urlBuilder';
import { logRouteIdException } from 'tools/log';
import { RouteEntry } from 'framework/routing/routeEntry';
import { ModuleProps } from 'framework/modules';

const bundles = require.context('../', true, /bundleDescription$/);
const routes = require.context('../', true, /route$/);

export type UrlRouterEntry<TProps extends ModuleProps> = {
	route: RouteEntry<TProps>;
	legacy?: boolean;
};

export default class RoutesTable {
	_urlRouter: UrlRouter<UrlRouterEntry<ModuleProps>>;

	routes: Record<string, string> = {};

	constructor() {
		this._urlRouter = new UrlRouter();

		for (const fileName of bundles.keys()) {
			const bundle = bundles(fileName) as {
				getDescriptions: () => RouteEntry<ModuleProps>[];
			};

			try {
				for (const description of bundle.getDescriptions()) {
					const url = description.url;

					if (this.routes[description.routeId]) {
						logRouteIdException('routeId duplicate, routeId: ', description.routeId, ' url: ', url);
					}

					this.routes[description.routeId] = url;

					if (!description.routeId) {
						logRouteIdException('no route id for:', url[0]);
					}

					this._urlRouter.add(url, { route: description, legacy: true });
				}
			} catch (e) {
				console.error(e);
			}
		}

		for (const fileName of routes.keys()) {
			const route = routes(fileName) as {
				getRoute: () => RouteEntry<ModuleProps>;
			};

			try {
				const routeEntry = route.getRoute();
				const url = routeEntry.url;
				if (this.routes[routeEntry.routeId]) {
					logRouteIdException('routeId duplicate, routeId: ', routeEntry.routeId, ' url: ', url);
				}
				this.routes[routeEntry.routeId] = url;
				if (!routeEntry.routeId) {
					logRouteIdException('no route id for:', url);
				}
				this._urlRouter.add(url, { route: routeEntry });
			} catch (e) {
				console.error(e);
			}
		}
	}

	find(url: string) {
		const urlBuilder = new UrlBuilder(url);

		const route = this._urlRouter.find(urlBuilder.path);
		if (route == null) {
			return null;
		}

		if (route.params.id == 'new') {
			route.params.id = null;
		}

		const urlRouterEntry = route.handler;

		return {
			params: { ...route.params, ...urlBuilder.params, ...route?.params },
			entry: urlRouterEntry,
		};
	}
}
